import Image from 'next/image';

import styles from './MissionVision.module.scss';

const MissionVision = () => {
  return (
    <section className={styles.container}>
      <h2 className={styles.title}>
        Sứ mệnh và tầm nhìn của PipFarm khi tham gia vào thị trường Việt Nam là gì?
      </h2>
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.imageWrapper}>
            <Image
              src="/images/landing_page_pipfarm/Vector.png"
              alt="Vector Icon"
              width={80}
              height={80}
              className={styles.image}
            />
          </div>
          <p>
            Nhiều quỹ không cung cấp dịch vụ tại Việt Nam. Sứ mệnh của chúng tôi là giới thiệu
            nền tảng cTrader và mô hình giao dịch quỹ tới các nhà giao dịch Việt Nam với một đội
            ngũ hỗ trợ chuyên nghiệp.
          </p>
        </div>
        <div className={styles.card}>
          <div className={styles.imageWrapper}>
            <Image
              src="/images/landing_page_pipfarm/Chart.png"
              alt="Chart Icon"
              width={80}
              height={80}
              className={styles.image}
            />
          </div>
          <p>
            Chúng tôi cung cấp một nền tảng và mô hình giao dịch tốt hơn. Giao dịch với sàn môi
            giới truyền thống yêu cầu bạn chịu rủi ro toàn bộ số tiền của mình, và áp lực tâm lý có
            thể dẫn đến quyết định sai lầm.
          </p>
        </div>
        <div className={styles.card}>
          <div className={styles.imageWrapper}>
            <Image
              src="/images/landing_page_pipfarm/Coin.png"
              alt="Coin Icon"
              width={80}
              height={80}
              className={styles.image}
            />
          </div>
          <p>
            Khả năng giao dịch với ít rủi ro hoàn toàn thay đổi tư duy của nhà giao dịch, và đó là
            điều mà giao dịch quỹ mang lại. Và cTrader là nền tảng tốt nhất để theo dõi thị trường,
            thực hiện lệnh và quản lý vị thế trên mọi thiết bị của bạn.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
